export default __webpack_public_path__ + "static/media/caja-arequipa.98b17f67.svg";